import { Component } from '@niknevis/vue-modules'
import Vue from 'vue'
import QTable from 'quasar/src/components/table/QTable.js';
import { Paginated } from '@/modules/shared/models/data'
import { InertiaQueryParamsService } from '@/modules/shared/services/inertia-query-params.service'

type RequestProps = {
  pagination: QTable['pagination']
}

@Component
export class QsPaginatableMixin extends Vue {
  constructor(
    protected readonly qs: InertiaQueryParamsService
  ) {
    super()
  }

  protected get model(): Paginated<any> {
    throw new Error('Please override model.')
  }

  protected get paginationProps() {
    return {
      page: this.model.meta.current_page,
      rowsPerPage: this.model.meta.per_page,
      rowsNumber: this.model.meta.total
    }
  }

  public get pagination(): QTable['pagination'] {
    return this.paginationProps
  }

  public set pagination(value) {
  }

  protected paginateWithProps(props: RequestProps) {
    if (props.pagination?.page) {
      return {
        page: props.pagination.page
      }
    }
  }

  updateTable(props: RequestProps) {
    const params = this.paginateWithProps(props)
    if (params) {
      this.qs.batchSetParams(params)
    }
  }
}
